module.exports = __webpack_public_path__ + "assets/images/pause.d2048cccf02f4c7c36310ffd1ba82a2b.svg";